<div class="mx-3 mat-elevation-z2">
  <div
    class="row justify-start align-center gap-3"
    style="padding: 0.5em 1em"
  >
    <div
      class="row-wrap justify-start align-end gap-3"
      style="padding: 0 1em"
    >
      <!-- Select Cliente -->
      <ng-select
        style="width: 200px"
        [items]="clientes"
        [(ngModel)]="idCliente"
        [hideSelected]="true"
        placeholder="Cliente"
        [searchable]="true"
        bindLabel="nombre"
        bindValue="_id"
        (change)="listar()"
      />

      <!-- Firmware -->
      <mat-form-field style="width: 200px">
        <mat-label>Versión de Firmware</mat-label>
        <input
          #firmwareSearch
          matInput
          placeholder="1.10"
          [(ngModel)]="firmware"
        />
        @if (firmware) {
          <button
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Clear"
            (click)="$event.stopPropagation(); firmware = undefined; listar()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      <!-- Estado -->
      <mat-form-field style="width: 200px">
        <mat-label>Estado</mat-label>
        <mat-select (selectionChange)="listar()" [(ngModel)]="estado">
          <mat-option [value]="true">Online</mat-option>
          <mat-option [value]="false">Offline</mat-option>
        </mat-select>
        @if (estado || estado === false) {
          <button
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Clear"
            (click)="$event.stopPropagation(); estado = undefined; listar()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>

    <div>
      <h2 style="margin: 0">Total Sirenas: {{ totalCount }}</h2>
    </div>
  </div>

  <div class="row-wrap justify-around align-center">
    <!-- Sirenas por cliente -->
    @if (chartOptionsCliente) {
      <div>
        <app-chart
          [(options)]="chartOptionsCliente"
          style="
            width: 350px;
            max-width: 90%;
            height: 400px;
            display: block;
            margin-top: 30px;
            margin: auto;
          "
        />
      </div>
    }

    <!-- Grafico sirenas por firmware -->
    @if (chartOptionsFirmware) {
      <div>
        <app-chart
          [(options)]="chartOptionsFirmware"
          style="
            width: 350px;
            max-width: 90%;
            height: 400px;
            display: block;
            margin-top: 30px;
            margin: auto;
          "
        />
      </div>
    }

    <!-- Sirenas por estado online -->
    @if (chartOptionsOnline) {
      <div>
        <app-chart
          [(options)]="chartOptionsOnline"
          style="
            width: 350px;
            max-width: 90%;
            height: 400px;
            display: block;
            margin-top: 30px;
            margin: auto;
          "
        />
      </div>
    }
  </div>
</div>
